/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import React from 'react';

export const ProgressBar = ({ id, max, value, label }) => {
  return (
    <Container>
      <MyLabel htmlFor={id}>{label}</MyLabel>
      <MyProgressBar id={id} max={max} value={value} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  gap: 4px;
  justify-content: flex-end;
  padding-top: 8px;
`;

const MyProgressBar = styled.progress`
  width: 40px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  opacity: 0.5;
  ::-webkit-progress-bar {
    background-color: ${Palette.PrimaryGray._100};
  }

  ::-webkit-progress-value {
    background-color: ${Palette.Teal._500};
  }
`;

const MyLabel = styled.label`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
